import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
var mapStateToProps = function (state, _a) {
    var commentableItemId = _a.commentableItemId, commentableTypeId = _a.commentableTypeId, parentId = _a.parentId;
    var total = getThreadState(state, commentableTypeId, commentableItemId, parentId).total;
    return { total: total };
};
export default connect(mapStateToProps);
//# sourceMappingURL=ThreadHeader.container.js.map